import { CircularProgress, Stack } from '@mui/material';

type LoaderScreenProps = {
    positionStatic?: boolean;
};

export const LoaderScreen = ({
    positionStatic = false,
}: LoaderScreenProps): JSX.Element => {
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            sx={
                positionStatic
                    ? {
                          position: 'static',
                          display: 'flex',
                          alignItems: 'center',
                          flex: '1 1',
                          minHeight: '100%',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                      }
                    : {
                          position: 'fixed',
                          top: 0,
                          left: 0,
                          width: '100%',
                          height: '100%',
                      }
            }
        >
            <CircularProgress variant="indeterminate" size={30} />
        </Stack>
    );
};
